import { useQuery } from '@apollo/client';

import { getAuthConfigKeysQuery } from '../../../../query';
import type { SavedAuthConfigKeysResult } from '../../../../types';

export function useGetAuthConfigKeys() {
  return useQuery<SavedAuthConfigKeysResult>(getAuthConfigKeysQuery);
}
